import { render, staticRenderFns } from "./PaymentSummaryTab.vue?vue&type=template&id=220f4d3b"
import script from "./PaymentSummaryTab.vue?vue&type=script&lang=js"
export * from "./PaymentSummaryTab.vue?vue&type=script&lang=js"
import style0 from "./PaymentSummaryTab.vue?vue&type=style&index=0&id=220f4d3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports